import { Typography } from '@mui/material'
import React, { memo } from 'react'
import tw from 'twin.macro'
import { ContractorPortalPaymentMethod } from 'src/interfaces/contractorPortal'
import { StitchPayoutDestinationType } from 'src/constants/stitch'
import { ContractorPortalPaymentMethodChip } from '../ContractorPortalPaymentMethodChip'

interface ContractorPortalStitchPaymentMethodDisplayProps {
  paymentMethod: ContractorPortalPaymentMethod | null
}

const ContractorPortalStitchPaymentMethodDisplayComponent = ({
  paymentMethod,
}: ContractorPortalStitchPaymentMethodDisplayProps) => {
  if (!paymentMethod?.data) {
    return (
      <div css={tw`mt-6`}>
        <Typography css={tw`text-shades-400`}>You have no active payment method</Typography>
      </div>
    )
  }

  return (
    <>
      <div css={tw`mt-4`}>
        <Typography css={tw`text-shades-400 uppercase`} variant="overline">
          Current PAYMENT method
        </Typography>
      </div>
      <div css={tw`flex mt-2 items-center flex-row p-4 rounded-2xl bg-shades-0`}>
        <div>
          <Typography css={tw`text-shades-1000`} variant="h4">
            {paymentMethod.type === StitchPayoutDestinationType.Card
              ? 'Debit Card'
              : 'Bank Account'}
          </Typography>
          <Typography css={tw`mt-0.5 text-shades-400 capitalize`}>
            {paymentMethod.type === StitchPayoutDestinationType.Card
              ? `${paymentMethod.data.cardType} • ${paymentMethod.data.lastDigits} • ${paymentMethod.data.expiration}`
              : `${(paymentMethod.data as any).subType} • ${paymentMethod.data.lastDigits}`}
          </Typography>
        </div>
        {paymentMethod.type === StitchPayoutDestinationType.Card &&
          paymentMethod.data.expiration && (
            <div css={tw`ml-auto`}>
              <ContractorPortalPaymentMethodChip expirationDate={paymentMethod.data.expiration} />
            </div>
          )}
      </div>
    </>
  )
}

export const ContractorPortalStitchPaymentMethodDisplay = memo(
  ContractorPortalStitchPaymentMethodDisplayComponent,
)
